import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import { anmodningStatusColors } from '../libs/mapStyles';
import { CardHeader } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
    position: 'relative',
    borderRadius: '4px',
  },
  cardContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
  messageContainer: {
    flex: 1,
  },
  statusTitle: {
    fontWeight: 600,
    fontSize: '16px',
    marginBottom: theme.spacing(0.5),
    color: '#ffffff',
  },
  statusMessage: {
    fontSize: '14px',
    color: '#ffffff',
    opacity: 0.95,
  },
  closeButton: {
    color: '#ffffff',
    marginLeft: theme.spacing(2),
  },
}));

const STATUS_MESSAGES = {
  'Gennemført': 'Denne anmodning er blevet gennemført succesfuldt og leveret.',
  'Hentet': 'Anmodningen behandles i øjeblikket.',
  'Mangler Manuel Håndtering': 'Denne anmodning kræver manuel håndtering før den kan gennemføres. Dette kan enten være på grund af datafejl, eller fordi området er udtaget til manuel behandling.',
  'Håndteret Manuelt': 'Denne anmodning er blevet håndteret manuelt af en administrator. Anmodningen er efterfølgdende gennemført successfuldt, eller markeret som gennemført af en administrator.',
  'Udtaget til paavisning': 'Denne anmodning er udtaget til påvisning og afventer yderligere behandling. Anmodningen er svaret til LER uden ledningsdata. Det er stadig nødvendigt at markere anmodningen som "Håndteret manuelt", når påvisningen er fuldført.',
};

export default function StatusBanner({ status }) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  if (!status) {
    return null;
  }

  const isHandledStatus = STATUS_MESSAGES[status];
  const message = isHandledStatus 
    ? STATUS_MESSAGES[status]
    : 'Denne status er ikke konfigureret. Kontakt venligst support på ler@geopartner.dk og oplys den aktuelle anmodning.';
  
  const backgroundColor = isHandledStatus 
    ? (anmodningStatusColors[status] || '#000000')
    : '#757575'; // Gray color for unhandled statuses

  return (
    <Collapse in={open}>
      <Card 
        className={classes.card} 
        raised
        style={{ backgroundColor }}
      >
        <CardContent className={classes.cardContent}>
          <div className={classes.messageContainer}>
            <div className={classes.statusTitle}>
              {isHandledStatus ? `Anmodningsstatus: ${status}` : `Ukendt status: ${status}`}
            </div>
            <div className={classes.statusMessage}>
              {message}
            </div>
          </div>
          <IconButton
            aria-label="close"
            size="small"
            className={classes.closeButton}
            onClick={() => setOpen(false)}
            hidden
          >
            <CloseIcon />
          </IconButton>
        </CardContent>
      </Card>
    </Collapse>
  );
}
